import { createFromIconfontCN } from '@ant-design/icons'

export const IconFont = createFromIconfontCN({
	scriptUrl: ['//at.alicdn.com/t/c/font_4395364_34cq3vidirk.js']
})
